/**
 * Hero Banner - Swiper & Progress Bar Controller
 * All banners (large, info, small) change together on each slide
 */
(function () {
    function initHeroBanners() {
        const heroBannerSections = document.querySelectorAll('[data-hero-banner-section]');

        heroBannerSections.forEach(function (section) {
            const swiperContainer = section.querySelector('[data-hero-banner-swiper]');
            const progressContainer = section.querySelector('[data-hero-banner-progress]');
            const progressSegments = section.querySelectorAll('[data-progress-segment]');
            const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 5;
            const slidesCount = parseInt(section.dataset.slidesCount, 10) || 1;

            if (!swiperContainer || slidesCount < 1) return;

            // Check if Swiper is available
            if (typeof Swiper === 'undefined') {
                console.warn('Hero Banner: Swiper library not found');
                return;
            }

            // Set CSS variable for progress animation duration
            section.style.setProperty('--autoplay-duration', autoplaySpeed + 's');

            // Initialize Swiper - Controls all banners at once
            const swiper = new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: slidesCount > 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 500,
                autoplay: slidesCount > 1 ? {
                    delay: autoplaySpeed * 1000,
                    disableOnInteraction: false,
                } : false,
                on: {
                    slideChange: function () {
                        updateProgressBar(this.realIndex);
                    },
                    init: function () {
                        updateProgressBar(0);
                    }
                }
            });

            // Progress bar click handlers - Using event delegation to support Swiper clones
            section.addEventListener('click', function (e) {
                const target = /** @type {HTMLElement} */ (e.target);
                if (!target || typeof target.closest !== 'function') return;
                const segment = /** @type {HTMLElement} */ (target.closest('[data-progress-segment]'));
                if (segment && segment.dataset) {
                    const index = parseInt(segment.dataset.progressSegment || '0', 10);
                    swiper.slideToLoop(index);
                    resetProgressAnimation();
                }
            });

            // Update progress bar segments
            function updateProgressBar(activeIndex) {
                const allSegments = section.querySelectorAll('[data-progress-segment]');
                if (!allSegments.length) return;

                allSegments.forEach(function (node) {
                    const segment = /** @type {HTMLElement} */ (node);
                    if (!segment.dataset) return;
                    const index = parseInt(segment.dataset.progressSegment || '0', 10);
                    segment.classList.remove('is-active', 'is-completed');

                    if (index < activeIndex) {
                        segment.classList.add('is-completed');
                    } else if (index === activeIndex) {
                        segment.classList.add('is-active');
                        // Trigger reflow to restart animation
                        const fill = segment.querySelector('.hero-banner__progress-fill');
                        if (fill) {
                            /** @type {HTMLElement} */ (fill).style.animation = 'none';
                            void /** @type {HTMLElement} */ (fill).offsetWidth; // Trigger reflow
                            /** @type {HTMLElement} */ (fill).style.animation = '';
                        }
                    }
                });
            }

            // Reset all progress animations
            function resetProgressAnimation() {
                const allSegments = section.querySelectorAll('[data-progress-segment]');
                allSegments.forEach(function (segment) {
                    const fill = segment.querySelector('.hero-banner__progress-fill');
                    if (fill) {
                        /** @type {HTMLElement} */ (fill).style.animation = 'none';
                        void /** @type {HTMLElement} */ (fill).offsetWidth;
                        /** @type {HTMLElement} */ (fill).style.animation = '';
                    }
                });
            }

            // Pause autoplay on hover (only if autoplay is enabled)
            if (slidesCount > 1) {
                swiperContainer.addEventListener('mouseenter', function () {
                    if (swiper.autoplay && swiper.autoplay.running) {
                        swiper.autoplay.stop();
                    }
                    // Pause progress animation
                    const activeSegments = section.querySelectorAll('.hero-banner__progress-segment.is-active .hero-banner__progress-fill');
                    activeSegments.forEach(function (fill) {
                        /** @type {HTMLElement} */ (fill).style.animationPlayState = 'paused';
                    });
                });

                swiperContainer.addEventListener('mouseleave', function () {
                    if (swiper.autoplay && !swiper.autoplay.running) {
                        swiper.autoplay.start();
                    }
                    // Resume progress animation
                    const activeSegments = section.querySelectorAll('.hero-banner__progress-segment.is-active .hero-banner__progress-fill');
                    activeSegments.forEach(function (fill) {
                        /** @type {HTMLElement} */ (fill).style.animationPlayState = 'running';
                    });
                });
            }
        });
    }

    // Initialize on DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHeroBanners);
    } else {
        initHeroBanners();
    }

    // Re-initialize on Shopify section load/unload (Theme Editor)
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (event) {
            if (event.target.classList.contains('hero-banner-section')) {
                setTimeout(initHeroBanners, 100);
            }
        });
    }
})();
